<template>
  <ul class="tabs tabs-bulk-upload-navigation" v-if="user && user.profile && user.profile.vetter">
      <li :class="{ active: $route.name == 'batchupload' }">
          <router-link class="tab__title" :to="{ path: '/data/batchupload/' }">
              Upload
          </router-link>
      </li>
      <li :class="{ active: $route.name == 'batchuploadreview' }">
          <router-link class="tab__title" :to="{ path: '/data/batchupload/review/' }">
              Review
          </router-link>
      </li>
      <li :class="{ active: $route.name == 'batchuploadimports' }">
          <router-link class="tab__title" :to="{ path: '/data/batchupload/imports/' }">
              Previous Imports
          </router-link>
          
      </li>
  </ul>
</template>

<script>
  export default {
    name: 'BulkUploadNavigation',
    props: ['user'],
  }
</script>


// WEBPACK FOOTER //
// src/components/BulkUploadNavigation.vue